import * as types from '../../actions/types';

const initialState = {
  loading: false,
  error: null,
  dashboardData: {},
};

const adminDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADMIN_DASHBOARD_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.ADMIN_DASHBOARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.FETCH_ADMIN_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        dashboardData: action.payload,
        error: null,
      };

    default:
      return state;
  }
};

export default adminDashboardReducer;
